module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_okunai-d603cf66f51fc4ebcbd597d33d34ebcf.jpg";